export const environment = {
    production: true,
    token_storage: 'analytic-lgw-token',
    api_url: 'https://api.aldaniti.net/private/clients/',
    nodejs_url: 'ws://lgnode.freemediainternet.com:9090',
    login_page: 'pages/login'
};



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/environments/environment.ts